import React from 'react'
import { string, array, func } from 'prop-types'
import classNames from 'classnames'
import Label from './../form-elements/label'

const ButtonGroup = ({
  label,
  options = [],
  value = null,
  fieldName,
  errorMessage,
  onValueChange,
  classesContainer = ''
}) => {
  const onButtonClick = e => {
    e.preventDefault()
    onValueChange(e.currentTarget.value)
  }
  const buttons = options.map((option, idx) => {
    const { label: optionLabel = option, value: optionValue = option } = option
    const btnClass = classNames('nft-form-btn nft-form-btn--outline', { 'nft-form-btn--outline--active': optionValue === value })
    return (
      <button
        className={btnClass}
        key={`btn-${idx}`}
        value={optionValue}
        onClick={onButtonClick}>
        {optionLabel}
      </button>
    )
  })
  const btnGroupContainer = classNames('nft-field', { 'has-error': !!errorMessage }, classesContainer)
  return (
    <div className={btnGroupContainer}>
      { label && <Label text={label} /> }
      <div className='nft-button-group' role='group' data-insights-funnel-step={fieldName}>
        { buttons }
      </div>
      {errorMessage && <p className='nft-error-msg'>{errorMessage}</p>}
    </div>
  )
}

ButtonGroup.propTypes = {
  label: string,
  options: array,
  value: string,
  fieldName: string.isRequired,
  errorMessage: string,
  onValueChange: func.isRequired,
  classesContainer: string
}

export default ButtonGroup